// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RU29","title":"Header_title__1fdfE","left":"Header_left__1bfPl","clinicName":"Header_clinicName__2NgJQ"};